export default function Footer() {
  return (
    <footer className="mt-12 pt-6 border-t border-gray-200">
      <div className="text-center text-sm text-gray-500">
        Powered by{' '}
        <a
          href="https://www.hostfully.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Hostfully
        </a>{' '}
        Platform Engineering
      </div>
    </footer>
  )
}
